import PracticeTeamSearch from "./containers/search/index";
import PracticeTeamShow from "./containers/show/index";
import PracticeTeamNew from "./containers/new/index";
import PracticeTeamEdit from "./containers/edit/index";

export {
  PracticeTeamSearch,
  PracticeTeamShow,
  PracticeTeamNew,
  PracticeTeamEdit,
};
